import { getIsLogin } from 'lowcode/utils/getIsLogin';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import HeaderUserLogin from './HeaderUserLogin';
import HeaderUserNone from './HeaderUserNone';
import './index.scss';
export const HideUserLocaleList = ['cn', 'tw', 'sa', 'nl'];
export default function HeaderUser() {
    const { locale = 'us' } = useRouter();
    const [isLogin, setIsLogin] = useState<any>(false);
    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);
    if (HideUserLocaleList.includes(locale)) {
        return null;
    }
    return (
        <div className="HeaderUser HeaderV2-r-item">
            {isLogin && (
                <>
                    <HeaderUserLogin />
                </>
            )}
            {!isLogin && (
                <>
                    <HeaderUserNone />
                </>
            )}
        </div>
    );
}
